import { cn as packageCn, en as packageEn, jp as packageJp, tw as packageTw } from '@eureka/utils/package-locale';

export const cn = {
    packages: packageCn,
    editionTag: {
        trial: '试用倒计时：<span class="text-red-500 font-[600]">{days}</span> <span class="text-black">天</span>',
        expire: '试用即将到期',
        freemium: '开启更强大的体验',
        upgrade: '升级',
    },
    packageDiff: {
        current: '当前订阅',
        overlimit: {
            packages: {
            },
            versions: {
                air: {
                    description: '',
                    features: [
                        '畅享更多使用次数，研究不再受限',
                        '多角度技术方案触手可及，拓宽您的研发视野',
                        '一站获取前沿技术知识、技能和思路，持续进阶',
                        '智能评估技术方案的可行性，稳健推进项目',
                        '多种搜索方式，快速定位全球专利和论文',
                        '轻松验证方案新颖性，快速撰写交底书'
                    ],
                },
                protect: {
                    features: [
                        '畅享更多使用次数，研究不再受限',
                        '多元搜索方式，精准定位全球专利和论文',
                        '快速验证技术想法创新性，获取专家级改进建议',
                        '智能生成技术交底书，简化研发文档工作',
                        '可视化技术路线图，概览技术发展和趋势'
                    ],
                },
                ip: {
                    features: [
                        '畅享更多使用次数，使用不再受限',
                        '生成专家级查新报告，确保技术可专利性',
                        '适配专利申请规范，轻松完成高质量说明书撰写',
                        '全维度图像对比，快速识别外观侵权风险'
                    ],
                },
                insights: {
                    features: [
                        '畅享更多使用次数，研究不再受限',
                        '快速生成高质量技术研究报告，助您科学决策',
                        '一键识别潜在竞争对手或合作伙伴，抢占先机',
                        '全景掌握行业格局，洞悉对手动态和技术布局',
                        '多角度技术方案触手可及，拓宽您的研发视野',
                        '轻松验证方案新颖性，快速撰写交底书'
                    ],
                },
                material: {
                    features: [
                        '获取更多使用次数，研究不再受限',
                        '应用第一性原理，深度探索技术方案',
                        '快速解析材料性能，提升选材与评估效率',
                        '自动提取金属成分，提供可视化解析',
                        '解读化合物结构，解锁更多高效方案'
                    ],
                },
                ls: {
                    features: [
                        '享受更多请求次数，基于全球数据为您提供生物医药领域的精准洞察。',
                        '高效文档处理，告别低效阅读，大幅提升文件上传量，智能解析海量文档。',
                        '自动解析化合物结构并生成马库什权利要求，加速专利撰写。',
                        '自动筛选针对特定靶点的候选抗体，加速抗体药物研发效率。',
                        '获得更全面的竞争情报和分析，辅助企业关键决策。'
                    ],
                },
            },
            header: {
                title: '您的体验已达上限',
                description: '升级至 <span class="text-eureka-500">{version}</span>，您将解锁以下权益：',
            },
            recommend: '推荐',
            buttonText: '现在升级',
            continue: '继续使用',
        },
        trialEnd: {
            title: '您的Eureka试用已结束',
            upgrade: '升级至付费版，畅享全部功能，释放无限创新潜力！',
            upgradeButton: '现在升级',
            continueButton: '继续使用',
        },
        muti: {
            title: '升级',
            description: '升级至企业版本，解锁更多功能。',
            expire: '{package} 倒计时 {days} 天',
            buttonText: '升级',
        },
        free: {
            title: '基础版',
            description: '帮助研发用户高效解决技术问题，满足基本研发需求。',
            price: '0',
            buttonText: '继续使用',
            features: [
                '技术信息探索 3次/月',
                '技术预研报告 1次/年',
                '订阅专家技术库 10个'
            ],
        },
        singleAirUpgrade: {
            title: 'Eureka Agent平台',
            description: '面向四大专业领域，灵活选择，满足您的专属需求。',
            buttonText: '现在升级',
            features: [
                '<b>研发创新</b>：探索技术方案，智能验证可行性与新颖性，护航创新全流程',
                '<b>知识产权</b>：精准查新和FTO分析，智能撰写说明书，加快专利申请进程和布局',
                '<b>新材料</b>：智能分析成分、性能及配方，推动材料创新',
                '<b>生物医药</b>：支持靶点验证、专利布局与临床分析，全流程助力药物研发'
            ],
        },
        premium: {
            title: '企业版',
            description: '升级至企业版本，解锁所有核心功能，显著提升您的使用体验。',
            price: '100',
            buttonText: '升级',
            features: [
                '技术方案探索',
                '设计失效分析',
                '技术信息探索 1000次/月',
                '技术项目预研报告 20次/年',
                '订阅专家技术库 20个'
            ],
        },
    },
    usageAmount: {
        DIMENSION_YEAR: '今年使用：{0}/{1}次',
        DIMENSION_MONTH: '今月使用：{0}/{1}次',
        DIMENSION_DAY: '今日使用：{0}/{1}次',
        title: '已生成',
        technical_research: '技术预研报告',
        tech_seek: '技术信息问答​',
        tech_mind: '技术方案探索',
        material_tech_mind: '材料技术方案探索',
        tech_fmea: '技术失效分析',
    },
    usageLimitModal: {
        description: '你的可用额度不足，请升级套餐或联系销售获取更多额度。',
    },
}

export const en = {
    packages: packageEn,
    editionTag: {
        trial: 'Remaining trial time: <span class="text-red-500 font-[600]">{days}</span> <span class="text-black">days</span>',
        expire: 'Trial is about to expire',
        freemium: 'Try Premium',
        upgrade: 'Upgrade',
    },
    packageDiff: {
        current: 'Current subscription',
        overlimit: {
            packages: {
            },
            versions: {
                air: {
                    description: '',
                    features: [
                        'Unlock more access, unleash your research potential',
                        'Access multi-angle technical solutions to broaden your R&D perspective',
                        'Instantly gain cutting-edge knowledge, skills, and ideas to stay ahead',
                        'Intelligently evaluate the feasibility of your solutions to move projects forward with confidence',
                        'Search global patents and papers in multiple ways for precise results',
                        'Easily validate the novelty of your ideas and draft disclosure documents quickly'
                    ],
                },
                protect: {
                    features: [
                        'Unlock more access, unleash your research potential',
                        'Search across global patent and paper databases',
                        'Get expert validation and improvement tips',
                        'Generate technical documents automatically',
                        'View technology trends through visual roadmaps'
                    ],
                },
                ip: {
                    features: [
                        'Enjoy more usage without limitations',
                        'Generate expert-level novelty reports to ensure patentability',
                        'Aligned with patent standards for easy, high-quality specification drafting',
                        'Full-spectrum image comparison to identify design infringement risks'
                    ],
                },
                insights: {
                    features: [
                        'Unlock more access, unleash your research potential',
                        'Fast, high-quality technical reports for smarter decisions',
                        'Instant competitor or partner identification to stay ahead',
                        'Full industry view to track rivals and tech trends',
                        'Multi-angle solutions to expand your R&D vision',
                        'Quick novelty checks and disclosure drafting'
                    ],
                },
                material: {
                    features: [
                        'Unlock more access, unleash your research potential',
                        'Apply first-principles thinking to explore technical solutions in depth ',
                        'Compare material properties instantly',
                        'Visualize metal compositions automatically',
                        'Decode structures for optimal solutions'
                    ],
                },
                ls: {
                    features: [
                        'Enjoy more requests and gain precise insights in the biomedical field based on global data.',
                        'Efficient document processing eliminates tedious reading, significantly increases file upload capacity, and intelligently analyzes vast amounts of documents.',
                        'Automatically analyze compound structures and generate Markush Claim Drafting, accelerating filing process.',
                        'Automatically screen antibody candidates for specific targets, speeding up antibody drug R&D efficiency.',
                        'Obtain more comprehensive competitive intelligence and analysis to assist key business decisions.'
                    ],
                },
            },
            header: {
                title: 'Usage Limit Reached',
                description: 'Upgrade to {version} to unlock:',
            },
            recommend: 'Recommendation',
            buttonText: 'Upgrade Now',
            continue: 'Continue with Basic',
        },
        trialEnd: {
            title: 'Your Eureka trial has ended!',
            upgrade: 'You\'ll lose access to the paid features unless you choose to upgrade your plan.',
            upgradeButton: 'Upgrade Now',
            continueButton: 'Continue with Basic',
        },
        muti: {
            title: 'Upgrade',
            description: 'Enhance your experience by unlocking more advanced features and functionalities.',
            expire: '{package} – {days} Days Left in Your Trial',
            buttonText: 'Upgrade',
        },
        free: {
            title: 'Basic',
            description: 'Helps R&D users efficiently solve technical issues and meet basic needs.',
            price: '0',
            buttonText: 'Keep basic version',
            features: [
                'Scope problem 3 times/month',
                'Quick research 1 time/year',
                'Subscribe to expert library 10'
            ],
        },
        singleAirUpgrade: {
            title: 'Eureka Agent Platform',
            description: '4 Vertical Packages — Choose Flexibly to Fit Your Needs.',
            buttonText: 'Upgrade',
            features: [
                '<b>R&D</b>: Explore technical solutions, intelligently verify feasibility and novelty, and safeguard end-to-end innovation.',
                '<b>IP</b>: Precise novelty searches and FTO analyses, intelligent specification drafting, and faster patent filing and portfolio planning.',
                '<b>Materials</b>: AI-driven analysis of composition, performance, and formulations to accelerate materials innovation.',
                '<b>Life Sciences</b>: Support target validation, patent strategy, and clinical analysis — AI empowers the full drug-development workflow.'
            ],
        },
        premium: {
            title: 'Enterprise',
            description: 'Upgrade to Enterprise to unlock all features and enhance your experience.',
            price: '100',
            buttonText: 'Upgrade',
            features: [
                'Find solutions to technical problems',
                'Evaluate technical feasibility',
                'Scope technical problems 1,000 times/month',
                'Quick research 20 times/year',
                'Subscribe to expert library 20'
            ],
        },
    },
    usageAmount: {
        DIMENSION_YEAR: 'used this year: {0}/{1} times',
        DIMENSION_MONTH: 'used this month: {0}/{1} times',
        DIMENSION_DAY: 'used today: {0}/{1} times',
        title: 'Usage limit',
        technical_research: 'Quick research',
        tech_seek: 'Scope problem',
        tech_mind: 'Find solutions',
        material_tech_mind: 'Find solutions for materials',
        tech_fmea: 'DFMEA Assistant',
    },
    usageLimitModal: {
        description: 'Your available usage quota is insufficient. Please upgrade your plan or contact sales to get more access.',
    },
}

export const jp = {
    packages: packageJp,
    editionTag: {
        trial: 'トライアルカウントダウン：<span class="text-red-500 font-[600]">{days}</span> <span class="text-black">日</span>',
        expire: 'トライアルがまもなく終了します',
        freemium: 'プレミアム解放',
        upgrade: 'アップ',
    },
    packageDiff: {
        current: '現在のサブスクリプション',
        overlimit: {
            packages: {
            },
            versions: {
                air: {
                    description: '',
                    features: [
                        '利用回数が増え、研究が制限されません',
                        '多角的な技術ソリューションにアクセスし、研究開発の視野を広げる',
                        '最先端の知識・スキル・アイデアを一括取得し、常にステップアップ',
                        '技術案の実現可能性をAIが評価し、プロジェクトを着実に前進',
                        '多様な検索方法で、世界中の特許・論文を素早く特定',
                        'アイデアの新規性を簡単に検証し、技術開示書を迅速に作成'
                    ],
                },
                protect: {
                    features: [
                        '利用回数が大幅に増加し、研究の制限を解消',
                        '多様な検索手段で、世界中の特許・論文を正確に特定',
                        '技術アイデアの革新性を迅速に検証し、専門的な改善提案を取得',
                        '技術開示書を自動生成し、開発文書作業を効率化',
                        '技術ロードマップを可視化し、技術の進展とトレンドを一目で把握'
                    ],
                },
                ip: {
                    features: [
                        '利用回数が増加、機能制限を解除',
                        '専門家レベルの先行技術調査レポートを自動生成',
                        '出願基準に準拠、高品質な明細書を簡単作成',
                        '多角的な画像比較で意匠侵害リスクを迅速特定'
                    ],
                },
                insights: {
                    features: [
                        '利用回数が増え、研究制限なし',
                        '高品質な技術レポートを迅速作成',
                        '競合・パートナーを即時特定して先手を打つ',
                        '業界全体を把握し、競合動向や技術を追跡',
                        '多角的な技術案で視野を拡大',
                        '新規性を確認し、開示書を素早く作成'
                    ],
                },
                material: {
                    features: [
                        '使用回数が増え、研究の制限を解除',
                        'ファーストプリンシプルを活用し、技術解決策を深掘り',
                        '材料特性を迅速に解析し、評価効率を向上',
                        '金属成分を自動抽出し、可視化で解析を支援',
                        '化合物構造を読み解き、より効率的な解決策を提案'
                    ],
                },
                ls: {
                    features: [
                        'より多くのリクエスト回数を享受し、グローバルデータに基づいてバイオ医薬分野の精密な洞察を提供します。',
                        '効率的な文書処理により、非効率な読み取りから解放され、ファイルアップロード容量が大幅に増加し、大量の文書をインテリジェントに解析します。',
                        '化合物構造を自動解析してマーカッシュクレームを生成、特許出願プロセスを高速化。',
                        '特定の標的に対する候補抗体を自動的にスクリーニングし、抗体医薬品の研究開発効率を向上させます。',
                        'より包括的な競合情報と分析を取得し、企業の重要な意思決定を支援します。'
                    ],
                },
            },
            header: {
                title: 'ご利用上限に達しました',
                description: '{version} にアップグレードすると、以下の特典をご利用いただけます：',
            },
            recommend: 'おすすめです',
            buttonText: 'グレードアップ',
            continue: '引き続き利用する',
        },
        trialEnd: {
            title: 'Eurekaの試用期間が終了しました',
            upgrade: '有料版にアップグレードして、すべての機能と無限の創造力を体験しましょう！',
            upgradeButton: 'グレードアップ',
            continueButton: '引き続き利用する',
        },
        muti: {
            title: 'アップグレード',
            description: '企業版にアップグレードして、より多くの機能を解放します。',
            expire: '{package} カウントダウン：{days}日',
            buttonText: 'アップグレード',
        },
        free: {
            title: '基本版',
            description: 'R&Dユーザーの技術問題を効率的に解決し、基本ニーズを満たします。',
            price: '0',
            buttonText: '基本版を維持する',
            features: [
                '技術情報探索 3回/月',
                '技術項目予備調査レポート 1回/年',
                '専門技術ライブラリの購読 10'
            ],
        },
        singleAirUpgrade: {
            title: 'Eureka Agent プラットフォーム',
            description: '4つの専門分野に対応し、柔軟に選択してニーズに対応。',
            price: '100',
            buttonText: 'アップグレード',
            features: [
                '<b>研究開発・イノベーション</b>：技術方案の探索、実現可能性と新規性のAI検証で、イノベーション全体を支援',
                '<b>知的財産</b>：正確な先行技術調査とFTO分析、AIによる明細書作成で、特許出願と戦略的構築を加速',
                '<b>新素材</b>：AIで成分・性能・配合を解析し、材料開発とイノベーションを推進',
                '<b>バイオ医薬</b>：標的検証、特許戦略、臨床分析を支援し、AIで創薬プロセス全体を加速'
            ],
        },
        premium: {
            title: '企业版',
            description: '企業版にアップグレードして、全機能を解放し体験を向上。',
            price: '100',
            buttonText: 'アップグレード',
            features: [
                '技術的な問題に対するソリューションを見つける',
                '技術的な実現可能性を評価する',
                '技術的な問題の範囲設定 1,000回/月',
                'クイックリサーチ 20回/年',
                '専門技術ライブラリの購読 20'
            ],
        },
    },
    usageAmount: {
        DIMENSION_YEAR: '今年使用：{0}/{1}回',
        DIMENSION_MONTH: '今月使用：{0}/{1}回',
        DIMENSION_DAY: '今日使用：{0}/{1}回',
        title: '使用回数',
        technical_research: 'クイックリサーチ',
        tech_seek: '技術情報問答',
        tech_mind: '技術ソリューション探索',
        material_tech_mind: '材料技術ソリューション探索',
        tech_fmea: 'クイックリサーチ',
    },
    usageLimitModal: {
        description: 'ご利用可能な枠が不足しています。プランをアップグレードするか、営業担当者にお問い合わせのうえ、利用枠を追加してください。',
    },
}

export const tw = {
    packages: packageTw,
    editionTag: {
        trial: '試用倒計時：<span class="text-red-500 font-[600]">{days}</span> <span class="text-black">天</span>',
        expire: '試用即將到期',
        freemium: '開啟更強大的體驗',
        upgrade: '升級',
    },
    packageDiff: {
        current: '現在的訂閱',
        overlimit: {
            packages: {
            },
            versions: {
                air: {
                    description: '',
                    features: [
                        '暢享更多使用次數，研究不再受限',
                        '多角度技術方案觸手可及，拓寬您的研發視野',
                        '一站獲取前沿技術知識、技能和思路，持續進階',
                        '智能評估技術方案的可行性，穩健推進專案',
                        '多種搜索方式，快速定位全球專利和論文',
                        '輕鬆驗證方案新穎性，快速撰寫交底書'
                    ],
                },
                protect: {
                    features: [
                        '暢享更多使用次數，研究不再受限',
                        '多元化搜尋方式，精準定位全球專利與論文',
                        '快速驗證技術創新性，獲得專家級改進建議',
                        '智能生成技術交底書，簡化研發文檔工作',
                        '視覺化技術路線圖，掌握技術發展與趨勢'
                    ],
                },
                ip: {
                    features: [
                        '享更多使用次數，功能不再受限',
                        '生成專家級查新報告，保障技術可專利性',
                        '符合專利申請規範，輕鬆撰寫高品質說明書',
                        '圖像全方位比對，快速識別外觀侵權風險'
                    ],
                },
                insights: {
                    features: [
                        '暢享更多使用次數，研究不再受限',
                        '快速生成高品質技術研究報告，助您科學決策',
                        '一鍵識別潛在競爭對手或合作夥伴，搶佔先機',
                        '全景掌握產業格局，洞悉對手動態與技術佈局',
                        '多角度技術方案觸手可及，拓寬您的研發視野',
                        '輕鬆驗證方案新穎性，快速撰寫交底書'
                    ],
                },
                material: {
                    features: [
                        '獲取更多使用次數，研究不再受限',
                        '應用第一性原理，深入探索技術方案',
                        '快速解析材料性能，提升選材與評估效率',
                        '自動提取金屬成分，提供可視化解析',
                        '解讀化合物結構，解鎖更多高效方案'
                    ],
                },
                ls: {
                    features: [
                        '享受更多請求次數，基於全球數據為您提供生物醫藥領域的精密洞察。',
                        '高效文件處理，告別低效讀取，大幅提升文件上傳量，智能解析海量文件。',
                        '自動解析化合物結構並生成馬庫什權利要求，加速專利申請。',
                        '自動篩選針對特定靶點的候選抗體，加速抗體藥品研發效率。',
                        '獲得更全面的競爭情報和分析，輔助企業關鍵決策。'
                    ],
                },
            },
            header: {
                title: '您的體驗已達上限',
                description: '升級至 {version}，您將解鎖以下權益：',
            },
            title: 'Eureka',
            recommend: '推薦',
            buttonText: '立即升級',
            continue: '繼續使用',
        },
        trialEnd: {
            title: '您的Eureka試用已結束',
            upgrade: '升級至付費版，暢享全部功能，釋放無限創新潛力！',
            upgradeButton: '立即升級',
            continueButton: '繼續使用',
        },
        muti: {
            title: '升級',
            description: '升級至企業版本，解鎖更多功能。',
            expire: '{package} 倒計時 {days} 天',
            buttonText: '升級',
        },
        free: {
            title: '基礎版',
            description: '幫助研發用戶有效率解決技術問題，滿足基本研發需求。',
            price: '0',
            buttonText: '繼續使用',
            features: [
                '技術信息探索 3次/月',
                '技術項目預研報告 1次/年',
                '訂閱專家技術庫 10個'
            ],
        },
        singleAirUpgrade: {
            title: 'Eureka Agent 平台',
            description: '面向四大專業領域，靈活選擇，滿足您的專屬需求。',
            buttonText: '升級',
            features: [
                '<b>研發創新</b>：探索技術方案，智能驗證可行性與新穎性，護航創新全流程',
                '<b>知識產權</b>：精準查新與 FTO 分析，智能撰寫說明書，加速專利申請與布局',
                '<b>新材料</b>：智能分析成分、性能及配方，推動材料研發創新',
                '<b>生物醫藥</b>：支持靶點驗證、專利布局與臨床分析，全流程助力藥物研發'
            ],
        },
        premium: {
            title: '企業版',
            description: '升級至企業版本，解鎖所有核心功能，大幅提升您的使用體驗。',
            price: '100',
            buttonText: '升級',
            features: [
                '技術方案探索',
                '設計失效分析',
                '技術信息探索 1000次/月',
                '技術項目預研報告 20次/年',
                '訂閱專家技術庫 20個'
            ],
        },
    },
    usageAmount: {
        DIMENSION_YEAR: '今年使用：{0}/{1}次',
        DIMENSION_MONTH: '今月使用：{0}/{1}次',
        DIMENSION_DAY: '今日使用：{0}/{1}次',
        title: '已生成',
        technical_research: '技術預備調查報告',
        tech_seek: '技術資訊問答',
        tech_mind: '技術方案探索',
        material_tech_mind: '材料解決方案探索',
        tech_fmea: '技術失效分析',
    },
    usageLimitModal: {
        description: '你的可用額度不足，請升級方案或聯絡銷售取得更多額度。',
    },
}
